/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'base-ui/dist/Button';
import Col from 'base-ui/dist/Col';
import Icon from 'base-ui/dist/Icon';
import { intl } from 'components/LocaleProvider';

import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

/**
 * MenuSearch.js
 *
 * Render the search form.
 */
const MenuSearch = ({ mobile }) => {
  const handleCreatePlaceholder = (pageType) => {
    const {
      labelSearchHealth,
      labelSearchPets,
      labelSearchTravel,
      labelSearchFitness,
      labelSearchAuto,
      labelSearchGeneric,
    } = messages;
    switch (pageType) {
      case 'health':
      case 'psychology':
      case 'family':
        return labelSearchHealth;
      case 'animals':
        return labelSearchPets;
      case 'travel':
        return labelSearchTravel;
      case 'fitness':
        return labelSearchFitness;
      case 'auto':
        return labelSearchAuto;
      case 'others':
      case 'decor':
      default:
        return labelSearchGeneric;
    }
  };

  const pageType = publicRuntimeConfig.analytics_datasource;

  return (
    <React.Fragment>
      {(mobile) ? (
        <form className="search" action={`${publicRuntimeConfig.PUBLIC_URL}/`} method="get" target="_top">
          <input type="text" placeholder={intl.formatMessage(handleCreatePlaceholder(pageType))} name="s" />
          <Button
            type="submit"
            color="white"
            textColor="main"
            borderColor="white"
            tag="button"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Search',
                label: 'Search'
              }
            })}
          >
            <Icon name="search" prefix="fas" />
          </Button>
        </form>
      ) : (
        <Col md="1" className="search hidden-md end-xs">
          <form className="end-xs" action={`${publicRuntimeConfig.PUBLIC_URL}/`} method="get" id="searchform" target="_top">
            <label htmlFor="menu-search-input" className="display-none">
              {intl.formatMessage(handleCreatePlaceholder(pageType))}
            </label>
            <input id="menu-search-input" type="text" placeholder={intl.formatMessage(handleCreatePlaceholder(pageType))} name="s" />
            <Button
              type="submit"
              tag="button"
              rounded
              color="main"
              borderColor="main"
              textColor="white"
              data-with-google-events="true"
              data-google-events={JSON.stringify({
                data: {
                  action: 'click',
                  category: 'Search',
                  label: 'Search'
                }
              })}
            >
              <Icon name="search" prefix="fas" />
            </Button>
          </form>
        </Col>
      )}
    </React.Fragment>
  );
};

MenuSearch.propTypes = {
  mobile: PropTypes.bool,
};

export default MenuSearch;
